<template lang="pug">
    .play-box
        template(v-if='!isLoading')
                game-header(
                    v-if="!isBattle"
                    @soundStateChanged ="headerKey = !headerKey"
                    :key="headerKey"
                    :slug='type',
                    :game-type='parameters && parameters.courseType',
                    :is-homework="!!exerciseId",
                )
                .play-box__game(v-if='gameStarted && !gameFinished')
                    .play-box__example
                        .play-box__header(:class="{'mobile-version': isMobile}")
                            .play-box__scaling-bar-block
                                scaling-bar(
                                    v-model="fontSize"
                                    :element-name="elementName"
                                    :key="clientWidth"
                                )
                        template
                            .play-box__overflow-container
                                div(:style="wordStyle")
                                    div(v-if="!isCorrectAnswerChosen")
                                        | {{ examples[currentLevel].example }}
                                    .play-box__whole_words(v-if="isCorrectAnswerChosen")
                                        .play-box__whole_word(
                                            v-for="word in wholeWordForCurrentExample"
                                            :style="word.colorTheLetter && {'border-bottom': '2px solid hsl(121, 33%, 48%)'}"
                                            ) {{ word.letter }}
                                .play-box__answers-field(v-if="!isDictationMode" :style="wordStyle")
                                    .play-box__answer(
                                        v-for="(answer, index) in possibleAnswers"
                                        :key="index",
                                        ref="possibleAnswersElements"
                                        :style="getAnswerStyle(answer)"
                                        @click="processReply(false, answer)"
                                        )  {{ answer }}
                                cs-button.play-box__next-example-button(
                                    v-if="isCorrectAnswerChosen",
                                    @click="nextExample",
                                    pattern="primary-outline",
                                    color="blue"
                                    )  {{ $i18n.t('olympiads.olympiads_processStage_further') }}
                .game-info__block(v-if="gameStarted && !gameFinished")
                        game-info(
                            :score="{left: answers.good, right: answers.bad}"
                            :time="getTime"
                            :slug="type"
                            :parameters="parameters"
                            :game-allows-tips="false"
                            :opponent="opponent"
                            :opponent-numbers="opponentNumbers"
                            :is-opponent-answering="isOpponentAnswering"
                            :is-from-battle="isBattle"
                            :is-olympiad="isOlympiad"
                        )
                .divide-it-right__answer-buttom(v-if='isDictationMode && gameFinished && !showAnswersInDictationMode')
                    img.divide-it-right__answer-turtle(:src="turtle")
                    cs-button(@click='showAnswerInDictationMode' v-focus='')
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_showAnswers') }}
                examples-viewer(
                    v-if="showAnswersInDictationMode"
                    :examples-array="examplesArrayForDicationMode"
                )
                .play-box__end-container(v-if='gameFinished && !isOlympiad && !isDictationMode')
                    fireworks(
                        v-if="gameFinished && !isOlympiad && gameResult === 'success' "
                        :is-mobile="isMobile"
                    )
                    .play-box__reaction-container
                            .play-box__answers.play-box__answers--left
                                | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                                br
                                | {{ getTime }}
                            result-image.play-box__image(:status="gameResult")
                            .play-box__answers.play-box__answers--right
                                | {{ $i18n.t('dashboard.dashboard_sidebar_statistics') }}
                                br
                                | {{ answers.good }} / {{ answers.bad }}
                    result-buttons(
                        v-if="!isBattle"
                        :exercise-id="exerciseId"
                        :games-type="parameters.courseType"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
                calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import VocabularyWordsRus from '../../../../api/games/vocabularyWordsRusGameItems';
    import ScalingBar from './ScalingBar.vue';
    import textScrollMixin from '../../../../utils/trainer/textScroll';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import Battle from '../../../../utils/battle/battleMixin';
    import olympiadRussianLanguageAnswerTimerMixin from '../../../../utils/olympiads/olympiadRussianLanguageAnswerTimerMixin.js';
    import { cloneDeep, uniq } from 'lodash';
    import CsButton from '@/elements/CsButton.vue';
    import CsLoader from '@/elements/CsLoader.vue';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';
    import ExamplesViewer from './ExamplesViewer.vue';

    function DEFAULT_DATA() {
        return {
            examples: null,
            fontSize: '4',
            clientWidth: 0,
            currentLevel: 0,
            answers: { good: 0, bad: 0 },
            selectedAnswer: null,
            correctAnswer: null,
            isCorrectAnswerChosen: false,
            showAnswersInDictationMode: false,
        };
    }

    export default {
        mixins: [textScrollMixin, playBoxGameMixin, olympiadRussianLanguageAnswerTimerMixin, Battle],
        data() {
            return DEFAULT_DATA();
        },
        mounted() {
            document.addEventListener('keydown', this.handleKeyPress);
        },
        beforeDestroy() {
            this.beforeTabClosed();
            document.removeEventListener('keydown', this.handleKeyPress);
            window.removeEventListener('beforeunload', this.beforeTabClosed);
        },
        watch: {
            time: {
                handler(val) {
                    if (
                        this.parameters?.timeLimit !== 0 &&
                        val >= this.parameters?.timeLimit * 60 &&
                        !this.gameFinished
                    ) {
                        this.finishGame();
                    }
                    if (this.isDictationMode && val % this.parameters?.timeForAnswer === 0) {
                        this.nextExample();
                    }
                },
            },
        },
        computed: {
            possibleAnswers () {
                const string = this.examples[this.currentLevel].options
                const arr = string.split('').filter(item => /^[a-zA-Zа-яА-ЯёЁ-]$/.test(item));
                return uniq(arr);
            },
            examplesArrayForDicationMode() {
                const arr = cloneDeep(this.examples);
                arr.length = this.parameters.amountOfExamples;
                return arr;
            },
            turtle() {
                return require(`../../../../assets/images/turtle/ru/ru_AnswerTurtle.svg`);
            },
            gameResult() {
                if (this.answers.good >= this.answers.bad) return 'success';
                else return 'failure';
            },
            elementName() {
                return 'play-box__field';
            },
            wordStyle() {
                return {
                    'font-size': this.fontSize + 'em',
                };
            },
            isDictationMode() {
                return this.parameters.dictation;
            },
            wholeWordForCurrentExample() {
                return this.examples[this.currentLevel].wholeWord.split('').map(letter => {
                    if (letter === this.correctAnswer) {
                        return {
                            letter,
                            colorTheLetter: true,
                        };
                    } else {
                        return {
                            letter,
                            colorTheLetter: false,
                        };
                    }
                });
            },
            isInfiniteAmountOfExamples() {
                return this.parameters.timeLimit || this.parameters.infinityAmountOfExamples;
            },
        },
        methods: {
            handleKeyPress(event) {
                if (event.key === 'Enter') {
                    if (!this.isDictationMode && this.isCorrectAnswerChosen && !this.gameFinished) {
                        return this.nextExample();
                    };
                }
            },
            showAnswerInDictationMode() {
                this.showAnswersInDictationMode = true;
            },
            registerSounds() {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
                this.$createjs.Sound.registerSounds(this.soundObjects);
            },
            fetchData() {
                this.getExercise()
                    .then(() => {
                        VocabularyWordsRus.getItemsByRequest({
                            isInfiniteAmountOfExamples: this.isInfiniteAmountOfExamples,
                            amountOfExamples: this.parameters.amountOfExamples,
                            classes: this.parameters.selectedClasses.map(obj => obj.value)
                        })
                            .then(data => {
                                this.examples = data;
                                this.startGame();
                                this.registerSounds();
                                this.isLoading = false;
                            })
                            .catch(e => this.showErrorMessage(e));
                    })
                    .catch(e => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            refreshGameStatBeforeSend() {
                this.gameStat.answers = this.answers.good;
                this.gameStat.amountOfMistakes = this.answers.bad;
                this.gameStat.attempts = this.answers.good + this.answers.bad;
                this.gameStat.isCompleted = this.isInfiniteAmountOfExamples ? true : this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.amountOfExamples = this.parameters.amountOfExamples;
                this.gameStat.parameters = cloneDeep(this.parameters);
            },
            startGame() {
                this.gameStarted = true;
                this.startTimer();
            },
            startTimer() {
                this.startAnswerTimer();
                this.$nextTick(() => {
                    if (!this.timer) {
                        this.setTimer();
                    }
                });
            },
            processReply(finishExample = false, answer) {
                if (finishExample) {
                    this.answers.bad++;
                    return this.nextExample();
                }
                if (this.isDictationMode) return;
                if (this.isCorrectAnswerChosen) return;
                this.selectedAnswer = answer;
                const selectedAnswer = this.selectedAnswer === "-" ? "" : this.selectedAnswer;
                const constructedWord = this.examples[this.currentLevel].example.replace('_', selectedAnswer);
                if (constructedWord === this.examples[this.currentLevel].wholeWord) {
                    this.correctAnswer = answer;
                    this.answers.good++;
                    this.isCorrectAnswerChosen = true;
                } else {
                    this.answers.bad++;
                }
                if (this.isOlympiad || this.isBattle) {
                    return this.nextExample();
                }
            },
            nextExample() {
                this.selectedAnswer = null;
                this.correctAnswer = null;
                this.isCorrectAnswerChosen = false;
                this.stopAnswerTimer();
                if (!this.isInfiniteAmountOfExamples && this.currentLevel === this.parameters.amountOfExamples - 1) {
                    this.finishGame();
                    return;
                }
                this.currentLevel++;
                this.startAnswerTimer();
            },
            finishGame() {
                this.gameFinished = true;
                this.stopTimer();
                if (!this.isDictationMode) {
                    this.soundInstance = this.$createjs.Sound.play('gameDone');
                    this.sendStat();
                }
            },
            getAnswerStyle(answer) {
                if (this.isDictationMode) {
                    return { borderColor: '#333' };
                }
                const isSelected = answer === this.selectedAnswer;
                const isCorrect = answer === this.correctAnswer;
                return {
                    borderColor: isSelected ? (isCorrect ? 'hsl(121, 33%, 48%)' : 'hsl(353, 100%, 62%)') : '#333',
                };
            },
            calculatePercent() {
                let total = this.answers.good + this.answers.bad;
                if (total > 0) {
                    return parseInt((this.answers.good / total) * 100);
                }
                return 0;
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
            beforeTabClosed() {
                if (this.gameStarted) {
                    this.gameFinished = true;
                    this.sendStat();
                }
                return null;
            },
        },
        components: {
            ExamplesViewer,
            CsLoader,
            CsButton,
            ScalingBar,
            CalculatingAnswers,
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/assets/sass/games/playbox.scss';

    .play-box {
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        width: 100%;
        align-items: center;
        flex-direction: column-reverse;
        @include media($md) {
            align-items: stretch;
            flex-direction: row;
        }
    }

    .mobile-version {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .play-box--warning {
        display: table;
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column-reverse;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__example {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 5;
        flex-direction: column;
        justify-content: center;
    }

    .play-box__overflow-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 7px;
        @include media($sm) {
            font-size: 8px;
        }
        @include media($md) {
            font-size: 9.5px;
        }
        @include media($lg) {
            font-size: 12px;
        }
        @include media($xl) {
            font-size: 14px;
        }
        @include media($xxl) {
            font-size: 16px;
        }
    }

    .play-box__field {
        padding: 0 20px;
        text-align: center;
        font-size: 18px;
        user-select: none;
        font-weight: bold;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .play-box__whole_words {
        display: flex;
    }

    .play-box__whole_word {
        min-width: 10px;
    }

    .play-box__words-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .play-box__answer-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .answer-container__header {
        margin-bottom: 20px;
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
    }

    .answer-container__input .cs-input {
        margin-bottom: 0;
        font-size: 52px;
        line-height: 62px;
        padding: 9px 15px;
        text-align: center;
        max-width: 330px;
    }

    .play-box__word {
        padding: 0 8px;
        margin: 0 10px 3px 0;
        cursor: pointer;
    }

    .play-box__word:last-child {
        margin-right: 0;
    }

    .play-box__word--selected {
        color: $x-color-white;
        background: $hsl-color-green-58;
    }

    .play-box__word--unselected {
        color: $x-color-white;
        background: $hsl-color-red-62;
    }

    .play-box__word--inverted {
        display: inline-block;
        transform: rotate(180deg);
        margin-right: 10px;
    }

    .play-box__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        font-weight: 500;
        font-size: 28px;
        line-height: 34px;
        margin-bottom: 20px;
    }

    .play-box__before-start-game-header {
        flex-direction: column;
    }

    .play-box__task {
        align-self: center;
    }

    .play-box__title {
        margin-bottom: 20px;
        text-align: center;
    }

    .play-box__scaling-bar-block {
        margin-left: 20px;
        @include media($xlg) {
            margin-left: 40px;
        }
    }

    .play-box__subtitle {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 0;
        justify-content: center;
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__answers--left {
        color: $hsl-color-green-58;
        margin-left: 20px;
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--right {
        color: $hsl-color-green-58;
        margin-right: 20px;
        @include media($lg) {
            margin-right: 35px;
        }
    }

    .play-box__answers--show-md {
        display: block;
    }

    .play-box__answers-container {
        display: flex;
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 40px;
        @media screen and (max-width: 1200px) {
            height: 400px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 25px;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__buttons--game {
        margin: 0 0 25px;
        justify-content: center;
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__game-info {
        align-self: flex-end;
        @include media($lg) {
            align-self: auto;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .play-box__answers-field {
        margin-top: 10px;
        display: flex;
        gap: 10px;
    }

    .play-box__answer {
        width: 1em;
        height: 1em;
        padding: 0.3em;
        border: 3px solid $hsl-color-gray-74;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .play-box__next-example-button {
        margin-top: 15px;
    }

    .divide-it-right__answer-buttom {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include inset-space($space-base);
    }

    .divide-it-right__answer-turtle {
        max-width: 180px;
        @include stack-space($space-base);
        @include media($xlg) {
            max-width: 240px;
        }
    }
</style>
